import React from 'react';
import { Play, Pause, SkipBack, SkipForward, X } from 'lucide-react';
import './NowPlaying.css';

interface Track {
  name: string;
  duration: string;
  isSingle?: boolean;
}

interface Album {
  title: string;
  year: string;
  tracks: Track[];
}

interface NowPlayingProps {
  playingTrack: number | null;
  album: Album;
  onPlayTrack: (trackId: number) => void;
  onClose: () => void;
}

const NowPlaying: React.FC<NowPlayingProps> = ({ 
  playingTrack, 
  album, 
  onPlayTrack, 
  onClose 
}) => {
  if (!playingTrack) return null;

  const currentTrack = album.tracks[playingTrack - 1];

  return (
    <div className="now-playing-global">
      <div className="now-playing-container">
        <div className="player-info">
          <h3>NOW PLAYING</h3>
          <p className="track-name">{currentTrack?.name}</p>
          <p className="album-name">{album.title} • {album.year}</p>
        </div>
        
        <div className="player-controls">
          <button className="control-btn">
            <SkipBack size={20} />
          </button>
          <button 
            className="control-btn play-btn"
            onClick={() => onPlayTrack(playingTrack)}
          >
            <Pause size={24} />
          </button>
          <button className="control-btn">
            <SkipForward size={20} />
          </button>
        </div>
        
        <div className="player-progress">
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: '45%' }}></div>
          </div>
          <span className="time">1:45 / {currentTrack?.duration}</span>
        </div>
        
        <button className="close-btn" onClick={onClose}>
          <X size={20} />
        </button>
      </div>
    </div>
  );
};

export default NowPlaying; 